import React, { useState} from 'react';
import ImageWrapper from '../ImageBuilderWrapper/ImageWrapper';
import ReviewOrder from '../ReviewOrder/ReviewOrder';
import { Container } from '@jcom/common-components';
import BrandingSection from '../Branding/Branding';
import ZoneDesignSection from '../ZoneDesign/ZoneDesign';
import { goBack, stoleImages, selectZoneNavigation} from '../../Utils/HomeUtil';
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel';
import './MobileNavigation.css';
import { PreviewModal } from '../modals/PreviewModal';

function MobileNavigation(props) {
	const [stepperContent, setStepperContent] = useState(false);
	const [showPreview, setShowPreview] = useState(false);

	return (
		<>
			{
				<div className='App'>
					{props.selectedTemplate && props.selectedStage !== 'stole-design' && (
						<div
							className='col-sm-12 col-12 col-md-6 designbody'
							id='mobile-designbody'>
							<div
								className='mobile-preview'
								>
								<i
									className='fa fa-expand'
									id='mobilepreview'
									aria-hidden='true'
									onClick={() => props.stolePreview(setShowPreview)}></i>
							</div>
							<ImageWrapper
								template={props.selectedTemplate}
								colorsList={props.colorList}
								id={1}
								zoomImage={props.zoomImage}
								cssClassName={'svg-div'}
								viewBox={'-300 0 1650.8 3060.8'}
								setLoading={props.setLoading}
								zoneImagePath={props.zoneImagePath}
								setZoneImagePath={props.setZoneImagePath}
							/>
						</div>
					)}
					<div
						className='col-sm-12 col-md-6 col-12 designbody'
						style={{ paddingLeft: '0px', paddingRight: '0px' }}>
						{props.selectedStage === 'stole-design' && (
							<CarouselProvider
								naturalSlideWidth={100}
								naturalSlideHeight={250}
								totalSlides={4}
								visibleSlides={1}
								currentSlide={1}>
								<Slider>
									{stoleImages.map((image, index) => (
										<Slide index={image.id} key={image.id}>
											<div key={image.id}>
												<div className='design-title'>{image.title}</div>
												<div className='design-price'>
													{props.stoleMeta &&
														props.stoleMeta.configContainer &&
														props.stoleMeta.configContainer.stoles[index]
															.pricePrefix}{' '}
													${props.stolePrice[image.id]}
												</div>
												<div className='design-zone'>
													{props.stoleMeta &&
														props.stoleMeta.configContainer &&
														props.stoleMeta.configContainer.stoles[index]
															.variantInfo}
												</div>
												{props.stoleType === image.id ? (
													<div className='icon_position'>
														<div className='select_icon'>
															<i className='tick'></i>
														</div>
													</div>
												) : (
													''
												)}
												<img
													id={image.id}
													className={
														props.stoleType === image.id
															? 'mt-3 img-select img-select-active'
															: 'mt-3 img-select'
													}
													onClick={(e) => {
														props.selectImage(e);
														props.next();
													}}
													src={props.stoleImagePath[image.id]}
													alt={image.id}
												/>
											</div>
										</Slide>
									))}
								</Slider>
								<DotGroup />
							</CarouselProvider>
						)}
						{stepperContent && (
							<div className='mobile-stepper-content'>
								<>
									<ul className='list-group'>
										<li className='list-group-item d-flex p-0'>
											<span className='borderForStepper' onClick={() => setStepperContent(!stepperContent)}>
												<i className='fas fa-times'></i>
											</span>
											<div
												className='buttonforMenu'
												style={{ fontWeight: 'bold' }}>
												<span className='listItemText'>{props.stoleMeta &&
														props.stoleMeta.mobileview.menu}</span>
												<p className='subText'>
													{props.currentStep} {props.stoleMeta &&
														props.stoleMeta.mobileview.stepCompleted}
												</p>
											</div>
										</li>
										<li
											className='list-group-item d-flex'
											onClick={() => {props.saveDesignFromModalShow(true);setStepperContent(!stepperContent);}}>
											<span className='borderForHeart'>
												<i className='fas fa-heart fa-4px'></i>
											</span>
											<button
												className='buttonForHeart'
												style={{ fontWeight: 'bold' }}>
												<span className='listItemText'>{props.stoleMeta &&
														props.stoleMeta.mobileview.save}</span>
											</button>
										</li>
										{props.stoleMeta.mobileview.stepperItems &&
											props.stoleMeta.mobileview.stepperItems.map((step, index) => (
												<li
													className='list-group-item d-flex justify-content-between align-items-center'
													onClick={() => {
														if (props.visited.includes(index + 1)) {
															setStepperContent(!stepperContent);
															props.setSelectedStage(step.value);
														}
													}}>
													<div className='step-info'>
														<div className='step-name'>
															<span
																className='listItemStepNames'
																style={
																	props.visited.includes(index + 1)
																		? { fontWeight: 'bold' }
																		: { fontWeight: '0' }
																}>
																{index + 1}.{step.name}
															</span>
														</div>
														<div className='step-status'>
															{props.currentStep === index ? (
																<span className='completedText'>
																	{props.stoleMeta &&
														props.stoleMeta.mobileview.currentStep}
																</span>
															) : (
																(props.visited.includes(index + 1) && (index) < props.currentStep && (index !== 3)) && (
																	<>
																		<span className='checkCircleStep'>
																			<i className='fas fa-check-circle'></i>
																		</span>
																		<span className='completedText'>
																		{props.stoleMeta &&
														props.stoleMeta.mobileview.completed}
																		</span>
																	</>
																)
															)}
														</div>
													</div>
													{props.visited.includes(index + 1) && (
														<div>
															<span className='badge badge-primary badge-pill'>
																<i
																	className='fas fa-angle-right fa-lg'
																	style={{ color: 'BLACK TYPE #080808' }}></i>
															</span>
														</div>
													)}
												</li>
											))}
									</ul>
								</>
							</div>
						)}
						{!stepperContent && (
							<Container
								header={
									<p className='mobileheaderComponent'>
										<div className='mobile-nav-container'>
											{props.selectedStage !== 'stole-design' && (
												<div className='back-navigation'>
													<button
														className='previousIconButton'
														onClick={() => {
															if (
																props.selectedStage === 'school-branding' &&
																props.brandingTab === 0
															) {
																props.setSelectedStage('stole-design');
															} else {
																goBack(
																	props.selectedTemplate,
																	props.selectedStage,
																	props.setSelectedStage,
																	props.setBrandingTab,
																	props.brandingTab
																);
																selectZoneNavigation(props.selectedStage,props.brandingTab);
															}
														}}>
														<span className='nextIcon'>
															<i className='fas fa-angle-left fa-lg'></i>
														</span>
													</button>
												</div>
											)}
											<div className='header-text'>
												<span className='headContainerText'>
													{props.headerText}
												</span>
												<p className='subText'>	
												{props.stoleMeta &&
														props.stoleMeta.mobileview.step} {props.currentStep + 1} OF 4
												</p>
											</div>

											<div className='hamburger-menu'>
												<button
													className='hamburgerIconButton'
													onClick={() => setStepperContent(!stepperContent)}>
													<span className='hamburgerIcon'>
														<i className='fas fa-bars fa-1x'></i>
													</span>
												</button>
											</div>
											{props.selectedStage !== 'review-order' && <div className='next-navigation'>
												<button
													id='nextIconButton'
													className='nextIconButton'
													onClick={() => {
														selectZoneNavigation(props.selectedStage,props.brandingTab);
														props.next();
													}}>
													<span className='nextIcon'>
														<i className='fas fa-angle-right fa-lg'></i>
													</span>
												</button>
											</div>}
										</div>
									</p>
								}
								body={
									(props.selectedStage === 'school-branding' ? (
										<BrandingSection
											selectedTemplate={props.selectedTemplate}
											assetGroups={props.assetGroups}
											updateSelectedData={props.updateSelectedTemplate}
											colorList={props.colorList}
											stoleMeta={props.stoleMeta}
											brandingTab={props.brandingTab}
											setBrandingTab={props.setBrandingTab}
											getTabName={props.getBrandingTabName}
											setLoading={props.setLoading}
											fontList={props.fontList}
        							getFontList={props.getFontList}
											zoneImagePath={props.zoneImagePath}
											setZoneImagePath={props.setZoneImagePath}
										/>
									) : props.selectedStage.indexOf('your-stole') !== -1 ? (
										<ZoneDesignSection
											key={props.selectedZone}
											selectedZone={props.selectedZone}
											designSettings={props.selectedTemplate.designSettings}
											zoneAssets={props.zoneAssets}
											assetGroups={props.assetGroups}
											colorList={props.colorList}
											updateZoneData={props.updateZoneData}
											stoleMeta={props.stoleMeta}
											stolePreview={()=>props.stolePreview(setShowPreview)}
											getTabName={props.getZoneTabName}
											fontList={props.fontList}
        							getFontList={props.getFontList}
											zoneImagePath={props.zoneImagePath}
											setZoneImagePath={props.setZoneImagePath}
											zoneTextStatus={props.zoneTextStatus}
											setZoneTextStaus={props.setZoneTextStaus}
										/>
									) : (
										props.selectedStage === 'review-order' && (
											<ReviewOrder
												checkBoxValue={props.checkBoxValue}
												roZoneAssets={props.zoneAssets}
												sampleData={props.selectedTemplate}
												commonJSONText={props.stoleMeta}
												getRoPayload={props.getRoPayload}
												stoleType={props.stoleType}
												stolePreview={props.stolePreview}
												stoleMeta={props.stoleMeta}
												getTabName={props.getZoneTabName}
												colorList={props.colorList}
												addToCart={props.next}
												fontList={props.fontList}
												getFontList={props.getFontList}
												substemNameBranding={props.substemNameBranding}
												brandingTab={props.brandingTab}
												selectedStage={props.selectedStage}
												currentStep={props.currentStep}
												estimatedPrice={props.estimatedPrice}
											/>
										)
									))
								}
							/>
						)}
					</div>
				</div>
			}
			<PreviewModal
				id='previewModal'
				show={showPreview}
				previewImage={props.previewImage}
				onHide={() => (props.setPreviewImage(''), setShowPreview(false))}
				selectedTemplate={props.selectedTemplate}
			/>
		</>
	);
}
export default MobileNavigation;
